import { CastVariantIcon } from './CastVariantIcon';

/**
 * author: Google
 * id CD5DD59A-965F-455E-912B-9535BFD134E0
 * name cast-variant
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/cast-variant.svg
 * tags
 * - Home Automation 
 */
export const AirplayIcon = CastVariantIcon;
export default AirplayIcon